import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  forwardRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as CodeMirror from 'codemirror';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/edit/closebrackets.js';
import 'codemirror/addon/search/match-highlighter.js';

import { ConditionEditorHelper } from './condition-editor-helper';

const defaultConfig = {
  lineNumbers: false,
  theme: 'default readonly',
  indentAuto: true,
  smartIndent: true,
  indentUnit: 4,
  lineWrapping: true,
  matchBrackets: false,
  autoCloseBrackets: false,
  readOnly: true
};

@Component({
  selector: 'neq-condition-editor',
  template: '<textarea #host></textarea>',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NeqConditionEditorComponent),
      multi: true
    }
  ]
})
export class NeqConditionEditorComponent implements AfterViewInit {

  @Input() value = '';
  @Input() config = defaultConfig;
  @Input() formatting = true;

  @ViewChild('host') host;

  private codemirror = undefined;
  private helper: ConditionEditorHelper;

  ngAfterViewInit() {
    this.initCodemirror();
  }

  /**
   * Initialize the codemirror editor
   */
  initCodemirror() {
    this.codemirror = CodeMirror.fromTextArea(this.host.nativeElement, this.config);
    this.codemirror.setValue(this.value);

    this.helper = new ConditionEditorHelper(this.codemirror);
    this.format();
  }

  writeValue(obj: any): void {
    this.value = obj || '';

    if (this.codemirror) {
      this.codemirror.setValue(this.value);
    }
  }

  /**
   * Format the equation in the editor
   */
  format() {
    if (this.codemirror) {
      if (this.formatting) {
        this.helper.formatAndIndent();
      }
    }
  }

}
